
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { mockArticles } from "@/utils/mockArticles";
import { Article } from "@/types/article";
import { useSupabase } from "./useSupabase";
import { unformatArticleId } from "@/utils/articleIdValidation";

export const useSavedArticles = () => {
  const { user } = useSupabase();

  const { data: savedArticles = [], isLoading } = useQuery({
    queryKey: ['saved-articles', user?.id],
    queryFn: async () => {
      if (!user) {
        console.log("User not logged in, can't fetch saved articles");
        return [];
      }
      
      console.log("Fetching saved articles for user:", user.id);
      
      try {
        const { data: favorites, error } = await supabase
          .from('article_favorites')
          .select('article_id')
          .eq('user_id', user.id);

        if (error) {
          console.error("Error fetching favorites:", error);
          throw error;
        }

        console.log("Fetched favorites:", favorites);

        if (!favorites || favorites.length === 0) {
          return [];
        }

        // Process specially formatted mock article IDs
        const mockArticleIds = favorites
          .map(fav => fav.article_id?.toString() || "")
          .filter(id => id.startsWith('00000000-0000-4000-a000-'))
          .map(id => unformatArticleId(id));

        console.log("Extracted mock article IDs:", mockArticleIds);
        
        // Filter mock articles based on these IDs
        const savedArticles = mockArticles.filter(article => 
          mockArticleIds.includes(article.id.toString())
        );
        
        console.log("Filtered saved articles:", savedArticles);
        
        return savedArticles;
      } catch (err) {
        console.error("Error in useSavedArticles:", err);
        return [];
      }
    },
    enabled: !!user
  });

  return {
    savedArticles,
    isLoading
  };
};
